import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Inbox01 = function Inbox01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2.5 12h3.382A1.809 1.809 0 0 1 7.5 13c.3064.6129.9328 1 1.618 1h5.764a1.809 1.809 0 0 0 1.618-1c.3064-.6129.9328-1 1.618-1H21.5M8.9666 4h6.0668c1.0769 0 1.6153 0 2.0907.164.4204.145.8033.3816 1.121.6928.3592.3518.6.8334 1.0816 1.7966l2.1665 4.3331c.189.378.2835.567.3502.765.0592.176.1019.357.1276.5408.029.2069.029.4182.029.8408V15.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 20 18.8802 20 17.2 20H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.7202 2 16.8802 2 15.2v-2.0669c0-.4226 0-.6339.029-.8408a3 3 0 0 1 .1276-.5408c.0667-.198.1612-.387.3501-.765l2.1666-4.3331c.4816-.9632.7224-1.4448 1.0816-1.7967a3 3 0 0 1 1.121-.6927C7.3513 4 7.8897 4 8.9666 4"
    })
  }));
};
export default Inbox01;